var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { Component } from 'react';
import { BackgroundImage } from '@alife/simple-ui';
import LazyLoad from 'react-lazyload';
import { goldlog } from '@alife/intl-util';
import getCookieLocale from '../../../utils/cookie-utils';
var cookieLocale = getCookieLocale();
var MAP_LANG = {
    'en-us': 'en',
    'in-id': 'id',
    'th-th': 'th',
    'vi-vn': 'vi',
    'ms-my': 'ms',
};
var lang = MAP_LANG[cookieLocale] || 'en';
var CardUnpaid = (function (_super) {
    __extends(CardUnpaid, _super);
    function CardUnpaid() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CardUnpaid.prototype.render = function () {
        var _a = this.props, templateData = _a.templateData, cardType = _a.cardType;
        var productListJsonStr = JSON.parse(templateData.productListJsonStr);
        var handleClick = function (item) {
            if (item.prodUrlForPC) {
                goldlog({
                    key: '/lzdseller.im.message-card',
                    type: 'CLK',
                    method: 'POST',
                    data: {
                        prodId: item.prodId,
                        cardType: cardType,
                        type: 'product',
                        url: item.prodUrlForPC,
                    },
                });
                window.open(item.prodUrlForPC);
            }
        };
        return (React.createElement("div", { className: "card-unpaid message-card" },
            React.createElement("div", { className: "card-header" }, templateData.title),
            React.createElement("div", null, productListJsonStr.map(function (item) { return (React.createElement("div", { key: item.prodId, className: "card-content", onClick: function () { return handleClick(item); } },
                React.createElement(LazyLoad, { overflow: true, once: true, height: 72 },
                    React.createElement(BackgroundImage, { src: item.prodIconUrl, className: "lzd-pro-img" })),
                React.createElement("div", { className: "lzd-pro-desc" },
                    React.createElement("div", { className: "lzd-pro-title text-two-lines" }, JSON.parse(item.prodTitle)[lang] || JSON.parse(item.prodTitle)['en']),
                    React.createElement("div", { className: "lzd-pro-spec text-two-lines" }, JSON.parse(item.prodSpec)[lang] || JSON.parse(item.prodSpec)['en']),
                    React.createElement("div", { className: "lzd-price-num-wrapper" },
                        React.createElement("div", { className: "lzd-pro-price text-overflow" }, item.prodPriceStr),
                        React.createElement("div", { className: "lzd-pro-num text-overflow" }, JSON.parse(item.prodNum)[lang] || JSON.parse(item.prodNum)['en']))))); })),
            React.createElement("div", { className: "lzd-btn" },
                React.createElement("a", { onClick: function () {
                        goldlog({
                            key: '/lzdseller.im.message-card',
                            type: 'CLK',
                            method: 'POST',
                            data: {
                                cardType: cardType,
                                type: 'button',
                                url: templateData.buttonUrlPC,
                            },
                        });
                    }, target: "_blank", href: templateData.buttonUrlPC }, JSON.parse(templateData.buttonLabel)[lang] || JSON.parse(templateData.buttonLabel)['en']))));
    };
    return CardUnpaid;
}(Component));
export { CardUnpaid };
export default CardUnpaid;

//# sourceMappingURL=index.js.map
